var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"signup"},[_c('div',{staticClass:"signup_content"},[(_vm.isBack)?_c('div',{staticClass:"action",on:{"click":function($event){return _vm.$router.back()}}},[_c('img',{attrs:{"src":require('@/assets/image/hodgepodge/zuo.png'),"alt":""}})]):_vm._e(),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }